import { createContext, useContext, useEffect, useState } from "react"

export type ViewFormat = "chart" | "table"

const STORAGE_KEY = "campaign-view-format"

const CampaignViewFormatContext = createContext<{
  viewFormat: ViewFormat
  setViewFormat: (viewFormat: ViewFormat) => void
}>({
  viewFormat: "chart",
  setViewFormat: () => {},
})

const getInitialViewFormat = (): ViewFormat => {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === "table" || stored === "chart" ? stored : "chart"
}

export const CampaignViewFormatProvider = ({ children }: React.PropsWithChildren) => {
  const [viewFormat, setViewFormat] = useState<ViewFormat>(getInitialViewFormat)

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, viewFormat)
  }, [viewFormat])

  return (
    <CampaignViewFormatContext.Provider value={{ viewFormat, setViewFormat }}>
      {children}
    </CampaignViewFormatContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useCampaignViewFormat = () => {
  const context = useContext(CampaignViewFormatContext)
  if (!context)
    throw new Error("useCampaignViewFormat must be used within a CampaignViewFormatProvider")
  return context
}
